import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';
import { ReactComponent as Check } from '../../../assets/images/check.svg';
// import { ReactComponent as Add } from '../../../assets/images/add.svg';
import { Product } from '../../../library';

class ProductButton extends Component {

    render() {
        const {
            product,
            linkTitle,
            onOpenProduct,
            onSelectProduct,
            onQuantitySelected,
            isOpened,
            isSelected,
            dataLayer,
            selectedProduct,
            openProductsList,
        } = this.props;

        // onQuantitySelected is here to reset the Quantity when a new product is selected
        return (
            <div className={css(styles.productButton)}>
                <div className={css(styles.productButtonInner, isSelected ? styles.selected : isOpened ? styles.openedButton : '')} onClick={() => {onOpenProduct(); onQuantitySelected(null); onSelectProduct()}}>
                    <span className={css(styles.span)}>{product.title}</span>
                    { isSelected && <Check className={css(styles.check)} />}
                </div>
                <div className={css(styles.productContainer, isOpened ? styles.openedProduct : '')}>
                    <Product
                        data={product}
                        lightVersion
                        style={styles.product}
                        linkTitle={linkTitle}
                        dataLayer={dataLayer}
                        selectedProduct={selectedProduct}
                        onQuantitySelected={(quantity) => {this.props.onQuantitySelected(quantity)}}
                        openProductsList={(e) => openProductsList(e)}
                    />

                    {/* New presentation with a products list dropdown : no need for the select product button anymore */}
                    {/* <div className={css(styles.productSelectionButtonWrapper)}>
                        <div className={css(styles.productSelectionButton, isOpened ? styles.opened : '')} onClick={onSelectProduct}>
                            <Add fill="white" className={css(styles.addIcon)} />
                            <span>Select this product</span>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    }
}

export default ProductButton;
